/** PIC marketing: PDF WO memakai tanda tangan default di My profile, bukan status TTD work order. */
export function canOpenWorkOrderPdfPreview(opts: {
  canSign: boolean;
  hasProfileSignature: boolean;
  workOrderSigned: boolean;
}): boolean {
  if (opts.canSign) return opts.hasProfileSignature;
  return opts.workOrderSigned;
}

export function hasProfileSignature(row: { file_path?: string | null; sign?: string | null } | null): boolean {
  if (!row) return false;
  return Boolean(String(row.file_path ?? '').trim() || String(row.sign ?? '').trim());
}
